import { organizationApi } from "@infrastructure/api/organization.api";
export const organizationRepository = {
    async getMine() {
        const response = await organizationApi.getMine();
        return response.data ?? [];
    },
    async getAll() {
        const response = await organizationApi.getAll();
        return response.data ?? [];
    },
    async getOne(id, options = {}) {
        const response = await organizationApi.getOne(id, options);
        return response.data;
    },
    async create(payload) {
        const response = await organizationApi.create(payload);
        return response.data;
    },
    async update(id, payload, options = {}) {
        const response = await organizationApi.update(id, payload, options);
        return response.data;
    },
    async deactivate(id, payload = {}) {
        const response = await organizationApi.deactivate(id, payload);
        return response.data;
    },
    async reactivate(id, payload = {}) {
        const response = await organizationApi.reactivate(id, payload);
        return response.data;
    },
    async softDelete(id, payload) {
        const response = await organizationApi.softDelete(id, payload);
        return response.data;
    },
    async getBankAccounts(id, options = {}) {
        const response = await organizationApi.getBankAccounts(id, options);
        return response.data ?? [];
    },
    async addBankAccount(id, payload, options = {}) {
        const response = await organizationApi.createBankAccount(id, payload, options);
        return response.data;
    },
    async updateBankAccount(id, bankAccountId, payload, options = {}) {
        const response = await organizationApi.updateBankAccount(id, bankAccountId, payload, options);
        return response.data;
    },
    async removeBankAccount(id, bankAccountId, options = {}) {
        await organizationApi.removeBankAccount(id, bankAccountId, options);
    },
    async getBrandTheme(id, options = {}) {
        const response = await organizationApi.getBrandTheme(id, options);
        return response.data;
    },
    async updateBrandTheme(id, payload, options = {}) {
        const response = await organizationApi.updateBrandTheme(id, payload, options);
        return response.data;
    },
    async getMembers(id) {
        const response = await organizationApi.getMembers(id);
        return response.data ?? [];
    },
    async addMember(id, payload) {
        const response = await organizationApi.addMember(id, payload);
        return response.data;
    },
    async updateMember(id, userId, payload) {
        const response = await organizationApi.updateMember(id, userId, payload);
        return response.data;
    },
    async removeMember(id, userId) {
        await organizationApi.removeMember(id, userId);
    },
};
export default organizationRepository;
